// extracted by mini-css-extract-plugin
export default {"Dashboard":"dashboard_Dashboard__+DDuD","Subpage":"dashboard_Subpage__0-sAp"};